import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import categories from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat.name);
    setIsOpen(false);
    const a = document.createElement('a');
    a.href = cat.url;
    a.target = '_blank';
    a.rel = 'noopener nofollow';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <section className="w-full py-8 bg-background-100">
      <div className="max-w-2xl mx-auto px-4 md:px-8">
        <div ref={dropdownRef} className="relative">
          <label className="block text-sm font-medium text-foreground-700 mb-2">
            {t('categories.dropdown_label')}
          </label>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-3.5 bg-background-50 border border-background-200 rounded-xl text-sm text-foreground-800 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className={selected ? 'text-foreground-900' : 'text-foreground-400'}>
              {selected || '— ' + t('categories.dropdown_label') + ' —'}
            </span>
            <i className={`${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500 transition-transform duration-200`}></i>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-xl shadow-lg z-50 max-h-80 overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors text-left cursor-pointer whitespace-nowrap"
                >
                  <span className="w-7 h-7 flex items-center justify-center text-primary-500">
                    <i className={`${cat.icon} text-base`}></i>
                  </span>
                  {cat.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}